import * as React from 'react';

interface IUserObject {
    id: string;
    email: string;
    pre: string;
    sur: string;
}

interface IProps {
    user: IUserObject;
}

export default class UserName extends React.Component<IProps, void> {
    getUserName(user: IUserObject) {
        const parts = [];
        if(user.pre) {
            parts.push(user.pre);
        }
        if(user.sur) {
            parts.push(user.sur);
        }

        if(parts.length) {
            return parts.join(' ');
        }

        return user.email;
    }

    render() {
        const { user } = this.props;

        return (
            <span>{this.getUserName(user)}</span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/UserName.tsx